import type { Resource } from '../../';
export const product_details_contentBlocks_freeShipping_modal_paragraphTitle2: Resource = {"default":"Free Returns"};
